import React, { PropTypes } from "react";
import { Link, IndexLink } from "react-router";
import LoadingDots from "./LoadingDots";
import LoginLink from "./LoginLink";
import LogoutLink from "./LogoutLink";
import AdminLink from "./AdminLink";
import ExportLink from "./ExportLink";
import Updater from "../helpers/Updater";

const Header = ({ loading, signOut, auth, user }) => {
  let loginLogoutLink = auth.isLogged ? (
    <LogoutLink signOut={signOut} />
  ) : (
    <LoginLink />
  );
  let adminLink = user.isAdmin ? <AdminLink /> : null;

  return (
    <nav>
      <IndexLink to="/" activeClassName="active">
        Home
      </IndexLink>
      {" | "}
      <Link to="/contracts" activeClassName="active">
        Contratos
      </Link>
      {" | "}
      <Link to="/export" activeClassName="active">
        Export
      </Link>
      {" | "}
      <Link to="/config" activeClassName="active">
        Configuración
      </Link>
      {" | "}
      {loginLogoutLink}
      {loading && <LoadingDots interval={100} dots={20} />}
      {user.email == "seba@uc.cl" ? <Updater></Updater> : ""}
    </nav>
  );
};

Header.propTypes = {
  signOut: React.PropTypes.func.isRequired,
  auth: React.PropTypes.object.isRequired,
  user: React.PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/Header.js